import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { apiEntityViewsFetch } from '..';
import { TFetchError } from '../api-error.types';
import { EntityRole, GetEntityTeamRes } from '../entity/types';
import { TeamAssociateStatusType } from '../types';

export const ENTITY_VIEWS_QUERY_KEYS = {
  teamAssociates: 'entity-views-team-associates',
};

export interface GetEntityViewsTeamAssociatesParams {
  id: string | null;
  status?: TeamAssociateStatusType;
  role?: EntityRole;
  search?: string;
  page?: number;
  limit?: number;
}

export const _getEntityViewsTeamAssociates = ({
  id,
  status,
  role,
  search,
  page = 1,
  limit = 10,
}: GetEntityViewsTeamAssociatesParams) => {
  return queryOptions({
    enabled: !!id,
    placeholderData: keepPreviousData,
    queryKey: [ENTITY_VIEWS_QUERY_KEYS.teamAssociates, id, { status, role, search, page, limit }],
    queryFn: () =>
      apiEntityViewsFetch<GetEntityTeamRes>(`/${id}/team-associates`, {
        params: { status, role, search, page, limit },
      }),
  });
};

export const useIsEntityManageTeamAvailable = (id?: string | null) => {
  const { error, isLoading } = useQuery(
    queryOptions({
      enabled: !!id,
      queryKey: [ENTITY_VIEWS_QUERY_KEYS.teamAssociates, id, {}],
      queryFn: () =>
        apiEntityViewsFetch<GetEntityTeamRes>(`/${id}/team-associates`, {
          // Preventing entry into the global onResponseError
          onResponseError: () => {},
        }),
    }),
  );

  return {
    available: ![
      'ENTITY.BLOCKED.CANNOT_MANAGE_TEAM',
      'ENTITY.SUSPENDED.CANNOT_MANAGE_TEAM',
    ].includes((error as TFetchError)?.data?.code || ''),
    isLoading,
  };
};
